'use client';
import { useMediaQuery } from '@mui/material';
import ReactConfetti from 'react-confetti';

/** Success confetti, skipped when the user asked the system for reduced motion. */
export const Celebration = () => {
  const reduceMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  return reduceMotion ? null : <ReactConfetti recycle={false} numberOfPieces={500} />;
};
